import Tools from '../components/tools';
import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';

export default class Product {
    constructor() {
    	this.tools = new Tools();

        if(window.innerWidth > 767){
            this.navigation();
        } else {
            this.slider();
        }

        this.openSizingGuide();
        this.closeSizingGuide();
        this.getSize();

        this.ctaUrl = document.querySelector('.product .description-wrapper .description .text-container .cta').href;
    }

    navigation() {
    	window.onscroll = () => {
    		const fixedElt = document.querySelector('.product .description-wrapper .description');

    		let getTop = this.tools.offset( document.querySelector('section.product') ).top - document.querySelector('header').offsetHeight - 30,
    			getMaxTop = this.tools.offset( document.querySelector('section.product .imgs') ).top + document.querySelector('section.product .imgs').offsetHeight - (document.querySelector('header').offsetHeight + 30 + document.querySelector('.product .description-wrapper .description').offsetHeight);

    		if(window.pageYOffset > getTop){
    			fixedElt.classList.add('fixed');
    		} else {
    			fixedElt.classList.remove('fixed');
    		}

    		if(window.pageYOffset > getMaxTop){
    			fixedElt.classList.add('bottom');
    		} else {
    			fixedElt.classList.remove('bottom');
    		}
    	}
    }

    slider() {
        let s = tns({
            container: '.product .imgs'
        });
    }

    openSizingGuide() {
        const sizinghCta = document.querySelector('.product .description-wrapper .description .text-container .guide');
        if(sizinghCta){
            sizinghCta.addEventListener('click', function(){
                document.querySelector('.popin').style.display = 'block';
            });
        }
    }

    closeSizingGuide() {
        const overlayPopin = document.querySelector('.popin .overlay-popin');
        if(overlayPopin){
            overlayPopin.addEventListener('click', function(){
                this.parentElement.style.display = 'none';
            });
        }
    }

    getSize() {
        const select = document.querySelector('.product .description-wrapper .description .text-container select#size'),
              cta = document.querySelector('.product .description-wrapper .description .text-container .cta');

        const that = this;
        select.addEventListener('change', function(){
            console.log(this.value);
            if(this.value != ''){
                cta.classList.remove('disable');
                cta.href = that.ctaUrl + '&attribute_pa_size=' + this.value;
            }
        });
    }
}